import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Col, Empty, Form, Input, Row, Spin, Typography } from 'antd'
import Button from 'components/Button'
import useClient from 'hooks/useClient'
import { PERMISSIONS } from 'utils/constants'
import { getAboutUs, updateAboutUs } from 'redux/actions/aboutUs'

const { TextArea } = Input
const { Text } = Typography

const buildDefaultState = () => ({
  titleEn: '',
  titleAr: '',
  textEn: '',
  textAr: '',
})

const AboutUs = () => {
  const dispatch = useDispatch()
  const { isClientCan } = useClient()
  const canRead = isClientCan(PERMISSIONS.READ_ABOUT_US)
  const canUpdate = isClientCan(PERMISSIONS.UPDATE_ABOUT_US)

  const { item: about = null, isGetLoading, isChangeLoading } = useSelector(
    (state) => state.aboutUs || {},
  )

  const [state, setState] = useState(buildDefaultState())

  useEffect(() => {
    if (canRead) {
      dispatch(getAboutUs())
    }
  }, [canRead, dispatch])

  useEffect(() => {
    if (about) {
      setState({
        titleEn: about.titleEn || '',
        titleAr: about.titleAr || '',
        textEn: about.textEn || '',
        textAr: about.textAr || '',
      })
    } else {
      setState(buildDefaultState())
    }
  }, [about])

  const onFieldChange = (key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const onSave = () => {
    dispatch(
      updateAboutUs({
        data: state,
      }),
    )
  }

  if (!canRead) {
    return <Empty description="You do not have permission to view About Us" />
  }

  if (isGetLoading) {
    return (
      <div style={{ padding: 32, display: 'flex', justifyContent: 'center' }}>
        <Spin />
      </div>
    )
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h3 className="page-title">About Us</h3>
          <Text type="secondary">Manage the About Us content in English and Arabic.</Text>
        </div>
      </div>
      <div className="page-wrapper">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card title="About Us">
              <Form layout="vertical">
                <Row gutter={[16, 0]}>
                  <Col span={12}>
                    <Form.Item label="Title (EN)">
                      <Input
                        value={state.titleEn}
                        onChange={(e) => onFieldChange('titleEn', e.target.value)}
                        placeholder="English title"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Title (AR)">
                      <Input
                        dir="rtl"
                        style={{ textAlign: 'right' }}
                        value={state.titleAr}
                        onChange={(e) => onFieldChange('titleAr', e.target.value)}
                        placeholder="Arabic title"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Text (EN)">
                      <TextArea
                        value={state.textEn}
                        onChange={(e) => onFieldChange('textEn', e.target.value)}
                        rows={8}
                        placeholder="English text"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Text (AR)">
                      <TextArea
                        dir="rtl"
                        style={{ textAlign: 'right' }}
                        value={state.textAr}
                        onChange={(e) => onFieldChange('textAr', e.target.value)}
                        rows={8}
                        placeholder="Arabic text"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type="primary"
                  disabled={!canUpdate}
                  onClick={onSave}
                  loading={isChangeLoading}
                >
                  Save
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AboutUs

